<template>
  <div>
    <v-dialog
      v-model="showDialog"
      width="300"
    >
      <v-card
        dark
        color="#5bc36a"
      >
        <v-card-text>
          <div class="text-center pt-4">
            <img
              src="/static/images/user/line-notify-dialog.png"
              width="180"
            >
          </div>
          <div class="subheading white--text text-center">
            <div v-if="text">
              {{ text }}
            </div>
            <div v-else>
              請綁定 LINE  開啟巧巧郎推播通知，確保即時聯絡順利清關
            </div>
            <!-- 因正式報關訂單後續會跟您索取相關資料及確認預審報單，請連動LINE Notify開啟巧巧郎推播通知 -->
          </div>
          <div class="px-4 mt-4">
            <v-btn
              :loading="bindLineing"
              color="info"
              block
              large
              @click="bindLine"
            >
              開啟
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <DocEvent
      @visibilitychange="onVisibilitychange"
    />
  </div>
</template>
<script>
import { actOpenSysBrowser } from '@g/utils/appSDK'

export default {
  components: {
  },
  data () {
    return {
      showDialog: false,
      bindLineing: false,
      clicked: false,
      text: '',
    }
  },
  methods: {
    open () {
      this.showDialog = true
    },
    onVisibilitychange () {
      console.log(document.visibilityState)
      if (this.clicked) { // 有點擊過綁定LINE
        if (!document.hidden) {
          this.$store.dispatch('init')
        }
      }
    },
    async bindLine () {
      try {
        this.bindLineing = true
        let client = 'web-pc-notify'
        if (this.$store.state.project === 'mgb-pc') {
          client = 'web-mgbpc-notify'
        }
        this.clicked = true
        const res = await this.$store.dispatch('push/lineLogin/generateOauth2UrlBind', {
          client,
        })
        if (!res.data.error) {
          // sessionStorage.setItem('redirect', this.$route.fullPath)
          // window.location.href = res.data.message
          this.showDialog = false
          window.open(res.data.message, '_blank')
        }
      } finally {
        this.bindLineing = false
      }
    },
    async verify (text = '') {
      this.text = text
      if (!this.$store.state.userData.lineOpenUserId) {
        this.open()
        return false
      }
      return true
    },
  },
}
</script>
